import { CSSObject } from '@mantine/core';

export const resetPasswordContainerStyle: CSSObject = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
};